export default __webpack_public_path__ + "static/media/cathodicPro.8bdac06b.jpg";